var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    fill: "#F3F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 40V68H40V40H68ZM68 36H40C37.8 36 36 37.8 36 40V68C36 70.2 37.8 72 40 72H68C70.2 72 72 70.2 72 68V40C72 37.8 70.2 36 68 36ZM58.28 53.72L52.28 61.46L48 56.28L42 64H66L58.28 53.72Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse);
export default __webpack_public_path__ + "static/media/browse.189a16f3e84d3bc2a18ef6b59d38f989.svg";
export { ForwardRef as ReactComponent };